import { namespaceActions } from 'modules/redux-utils'
import { NAME } from './constants'

const HIDE_NOTIFICATIONS = 'HIDE_NOTIFICATIONS'
const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION'

export default namespaceActions(NAME)([HIDE_NOTIFICATIONS, CREATE_NOTIFICATION])
